// LocalStorage helpers for bookmarks, completion, recently-viewed, theme.
const KEY = {
  bookmarks: "cms_bookmarks_v1",
  completed: "cms_completed_v1",
  recent: "cms_recent_v1",
  theme: "cms_theme_v1",
};

const readSet = (k) => {
  try {
    const v = JSON.parse(localStorage.getItem(k) || "[]");
    return Array.isArray(v) ? new Set(v) : new Set();
  } catch {
    return new Set();
  }
};

const writeSet = (k, set) => {
  localStorage.setItem(k, JSON.stringify(Array.from(set)));
};

export const storage = {
  getBookmarks: () => Array.from(readSet(KEY.bookmarks)),
  isBookmarked: (slug) => readSet(KEY.bookmarks).has(slug),
  toggleBookmark: (slug) => {
    const s = readSet(KEY.bookmarks);
    if (s.has(slug)) s.delete(slug);
    else s.add(slug);
    writeSet(KEY.bookmarks, s);
    return s.has(slug);
  },

  getCompleted: () => Array.from(readSet(KEY.completed)),
  isCompleted: (slug) => readSet(KEY.completed).has(slug),
  toggleCompleted: (slug) => {
    const s = readSet(KEY.completed);
    if (s.has(slug)) s.delete(slug);
    else s.add(slug);
    writeSet(KEY.completed, s);
    return s.has(slug);
  },

  pushRecent: (slug) => {
    try {
      const arr = JSON.parse(localStorage.getItem(KEY.recent) || "[]");
      const next = [slug, ...arr.filter((s) => s !== slug)].slice(0, 8);
      localStorage.setItem(KEY.recent, JSON.stringify(next));
    } catch {
      /* ignore */
    }
  },
  getRecent: () => {
    try {
      return JSON.parse(localStorage.getItem(KEY.recent) || "[]");
    } catch {
      return [];
    }
  },

  getTheme: () => localStorage.getItem(KEY.theme) || "light",
  setTheme: (t) => localStorage.setItem(KEY.theme, t),
};
